export default __webpack_public_path__ + "static/media/overallaccuracy.f1e4801e.png";